import { ArrowRightAlt } from "@ellaandil/ui";
import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { renderRichText } from "@/components/bloks/utils";
import { Button } from "@/components/ui/Button";
import { Link as UiLink } from "@/components/ui/Link";
import { Prose } from "@/components/ui/Prose";
import type { TextSecondaryStoryblok } from "@/generated/sb/sb-types";
import { Link } from "@/i18n/routing";
import { sbLink } from "@/lib/storyblok/link";

export const TextSecondaryBlok = ({ blok }: BlokProps<TextSecondaryStoryblok>) => {
	const href = sbLink(blok.link)?.href;
	const buttonHref = sbLink(blok.buttonLink)?.href;

	return (
		<BlokWrap editable={blok}>
			<div className="flex flex-col items-start gap-grid-section-vertical-md">
				{blok.body && <Prose>{renderRichText(blok.body)}</Prose>}
				{blok.buttonLabel && buttonHref && (
					<Button as={Link} href={buttonHref} variant="solid" color="primary" size="large">
						{blok.buttonLabel}
					</Button>
				)}
				{blok.linkLabel && href && (
					<UiLink as={Link} href={href} variant="primary" size="large" rightIcon={ArrowRightAlt}>
						{blok.linkLabel}
					</UiLink>
				)}
			</div>
		</BlokWrap>
	);
};
